import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { redirectTo, RouteComponentProps } from '@reach/router';
import protectedRoute from '../../components/protectedRoute';
import Navigation from '../../components/Navigation/Navigation';
import messages from './messages';
import UserInfoManagerPanel from '../../components/UserInfoManagerPanel/UserInfoManagerPanel';
import ConfigManager from '../../components/MakhsanConfigPanel/ConfigManager';
import SecurityLogViewPanel from '../../components/UserInfoManagerPanel/SecurityLogViewPanel';
import { RootState } from 'store/store';
import { IThisUserState } from 'store/thisUser/thisUserSlice';

type IStateToProps = {
  thisUser: IThisUserState;
};

type OwnProps = RouteComponentProps;

type ComponentProps = OwnProps & IStateToProps;
type tabs = 'users' | 'configs' | 'systemLogs';

interface IComponentState {
  selectedTabId: tabs;
}

const makhsanTabs = [
  {
    id: 'users',
    label: messages.users,
    order: 1,
  },
  {
    id: 'configs',
    label: messages.configs,
    order: 1,
  },
  {
    id: 'systemLogs',
    label: messages.systemLogs,
    order: 1,
  },
];

class MakhsanPanel extends React.PureComponent<
  ComponentProps,
  IComponentState
> {
  state = {
    selectedTabId: 'users' as tabs,
  };

  setTab = (tab: tabs) => {
    this.setState({ selectedTabId: tab });
  };
  componentDidMount(): void {
    const { thisUser } = this.props;

    if (!thisUser.permissions!.includes('Edit_User')) {
      redirectTo('/homepage');
    }
  }

  render() {
    const { selectedTabId } = this.state;
    return (
      <div style={{ height: '100%' }}>
        <Navigation
          items={makhsanTabs}
          onSelect={this.setTab}
          defaultTab={selectedTabId}
          showItems={makhsanTabs.length > 1}
          title={messages.adminPanel}
        />
        <div style={{ height: 'calc(100vh - 4rem)' }}>
          {selectedTabId === 'users' && <UserInfoManagerPanel />}
          {selectedTabId === 'configs' && <ConfigManager />}
          {selectedTabId === 'systemLogs' && <SecurityLogViewPanel />}
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, OwnProps, RootState> = (
  state
) => {
  const thisUser = state.thisUser;
  return { thisUser };
};

export default protectedRoute(connect(mapStateToProps)(MakhsanPanel));
